import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { I18nModule } from '../../../../core/i18n';
import { CatalogArticleListModule, ScreenSizeModule, SpinnerModule } from '../../../../shared';
import { LoadMoreComponent } from '../../../../shared/components/load-more/load-more.component';
import { NoResultsModule } from '../../../../shared/components/no-results/no-results.module';
import { NotificationModule } from '../../../../shared/components/notification';
import { CampaignBannerCarouselModule } from '../../../../shared/components/price-campaign/campaign-banner-carousel/campaign-banner-carousel.module';
import { CampaignItemsModule } from '../../../../shared/components/price-campaign/campaign-items/campaign-items.module';
import { ProductListItemLoaderModule } from '../../../../shared/components/product-list-item-loader/product-list-item-loader.module';
import { CatalogBreadcrumbModule } from '../../components/catalog-breadcrumb/catalog-breadcrumb.module';
import { CatalogFilterModule } from '../../components/catalog-filter/catalog-filter.module';
import { CatalogHeaderModule } from '../../components/catalog-header/catalog-header.module';
import { CatalogSortModule } from '../../components/catalog-sort/catalog-sort.module';
import { CatalogComponent } from './catalog.component';

@NgModule({
  declarations: [CatalogComponent],
  exports: [CatalogComponent],
  imports: [
    CommonModule,
    I18nModule,
    CatalogHeaderModule,
    CatalogFilterModule,
    CatalogBreadcrumbModule,
    LoadMoreComponent,
    NoResultsModule,
    NzIconModule,
    ScreenSizeModule,
    ProductListItemLoaderModule,
    SpinnerModule,
    NgbNavModule,
    InfiniteScrollModule,
    CatalogArticleListModule,
    CampaignItemsModule,
    CampaignBannerCarouselModule,
    NotificationModule,
    CatalogSortModule,
    RouterModule.forChild([
      {
        path: '',
        component: CatalogComponent,
      },
    ]),
  ],
})
export class CatalogModule {}
